import { render, staticRenderFns } from "./CompareCountriesFundings.vue?vue&type=template&id=ee2622d0&scoped=true&"
import script from "./CompareCountriesFundings.vue?vue&type=script&lang=js&"
export * from "./CompareCountriesFundings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2622d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
